import { forwardRef } from "react";
import type { LucideProps } from "lucide-react";

/**
 * Shield-with-person icon, matching lucide's stroke-based style (24x24 viewBox,
 * stroke-width 2, round caps). Mirrors the upstream `shield-user` icon that
 * was added to lucide-react in v0.482+; we are pinned to ^0.462.0 per the
 * shadcn migration locked-versions table, so this lives as a local glyph
 * until that package is bumped.
 *
 * The signature matches `LucideIcon` so it is interchangeable with the
 * lucide-react icons referenced from `src/lib/footerLinks.ts`.
 */
export const ShieldUserIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      className,
      size = 24,
      strokeWidth = 2,
      color = "currentColor",
      ...rest
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <circle cx="12" cy="10" r="2" />
      <path d="M8.5 16a3.5 3.5 0 0 1 7 0" />
    </svg>
  ),
);

ShieldUserIcon.displayName = "ShieldUserIcon";
